import React from 'react';
import {
  Table,
  TableHeader,
  TableHeaderRow,
  TableHeaderCell,
  TableBody,
  TableRow,
  TableCell,
  Box,
  Text,
  Amount,
} from '@razorpay/blade/components';

export interface SalaryPreviewTableData {
  id: string;
  name: string;
  monthlyAmount: number;
  annualAmount: number;
}

export const SalaryPreviewTable = ({
  tableData,
  isLoading,
}: {
  tableData: SalaryPreviewTableData[];
  isLoading?: boolean;
}) => {
  return (
    <Box>
      <Table data={{ nodes: tableData }} showStripedRows={false} isLoading={isLoading}>
        {(tableData) => (
          <>
            <TableHeader>
              <TableHeaderRow>
                <TableHeaderCell>Earnings</TableHeaderCell>
                <TableHeaderCell textAlign="right">Monthly Amount</TableHeaderCell>
                <TableHeaderCell textAlign="right">Annual Amount</TableHeaderCell>
              </TableHeaderRow>
            </TableHeader>

            <TableBody>
              {tableData.map((component) => (
                <TableRow key={component.id} item={component}>
                  <TableCell>
                    <Text>{component.name}</Text>
                  </TableCell>
                  <TableCell textAlign="right">
                    <Amount value={component.monthlyAmount} currency="INR" suffix="decimals" />
                  </TableCell>
                  <TableCell textAlign="right">
                    <Amount value={component.annualAmount} currency="INR" suffix="decimals" />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </>
        )}
      </Table>
    </Box>
  );
};
